import { InvoiceFormConfig } from '../types';
import {
	laborConfig,
	partsConfig,
	equipmentConfig,
	travelConfig,
	freightConfig,
	miscellaneousConfig,
} from '../../SupplierInvoiceFormNew/CostSectionConfigs';
import { fetchTaxLineItemsForSupplier } from '../../../thunks/invoices_thunks';
import { getInvoiceNumber } from '../../../thunks/invoices_thunks';
import { getSanitisedWorkOrder } from '../../../utils/WorkOrderUtils';

export const createSupplierInvoiceConfig = (
	formData: any,
	workOrder: any,
	currentUser: any,
	history: any,
	onSubmit: (values: any, formInstance: any, scope: string) => Promise<any>,
	options?: {
		redirectForwardUrl?: string;
		creating?: boolean;
		updating?: boolean;
		createErrors?: string[];
		updateErrors?: string[];
		onSuccess?: (record: any) => void;
		parsedDataSnapshot?: any;
		onError?: (error: any) => void;
		onReset?: () => void;
		disableCosts?: boolean;
	}
): InvoiceFormConfig => {
	return {
		formType: 'invoice',
		fields: {
			scope: true,
			invoiceNumber: true,
			externalWorkOrderId: true,
			invoiceDate: true,
			paymentTerms: true,
			dueDate: true,
			fileAttachments: false,
		},
		lineItemSections: [
			{ type: 'labor', show: true, config: laborConfig },
			{ type: 'parts', show: true, config: partsConfig },
			{ type: 'equipment', show: true, config: equipmentConfig },
			{ type: 'travel', show: true, config: travelConfig },
			{ type: 'freight', show: true, config: freightConfig },
			{ type: 'misc', show: true, config: miscellaneousConfig },
		],
		tax: {
			type: 'lineItems',
			fetchTaxLineItems: (currencyId: string) => fetchTaxLineItemsForSupplier(currencyId) as any,
		},
		currency: {
			fetchInternally: true,
			source: 'supplierFacility',
		},
		onSubmit,
		validateInvoiceNumber: async (value: string, supplierFacilityId?: string) => {
			const sanitizedWO = getSanitisedWorkOrder(workOrder);
			const facilityId = supplierFacilityId || (sanitizedWO && sanitizedWO.supplierFacilityId);
			return getInvoiceNumber(value, facilityId) as any;
		},
		formData,
		workOrder,
		currentUser,
		history,
		parsedDataSnapshot: options && options.parsedDataSnapshot,
		redirectForwardUrl: options && options.redirectForwardUrl,
		creating: options && options.creating,
		updating: options && options.updating,
		createErrors: options && options.createErrors,
		updateErrors: options && options.updateErrors,
		onSuccess: options && options.onSuccess,
		onError: options && options.onError,
		onReset: options && options.onReset,
		disableCosts: options && options.disableCosts,
	};
};
